export default __webpack_public_path__ + "static/media/benefit_11@3x.c7dd055d.png";